/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserNotificationSettingsResponseDto } from '../../models/user-notification-settings-response-dto';

export interface GetUserNotificationSettings$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getUserNotificationSettings(http: HttpClient, rootUrl: string, params: GetUserNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getUserNotificationSettings.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserNotificationSettingsResponseDto>;
    })
  );
}

getUserNotificationSettings.PATH = '/api/users/{id}/notification-settings';
